import classes from './Pill.module.scss'

export const Pill = ({ children, backgroundColor, textColor }) => {
  return (
    <span className={`${classes.pill}`} style={{ backgroundColor: backgroundColor, color: textColor }}>
      {children}
    </span>
  )
}
